import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  hiddenHeader = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private translate: TranslateService,
    private router: Router,
    private location: Location
  ) { }

  ngOnInit() {
    this.translate.addLangs(['en', 'de', 'it', 'es', 'pt']);
    this.translate.setDefaultLang('en');
    const browserLang = this.translate.getBrowserLang();
    this.translate.use((browserLang === 'en' || browserLang === 'de' || browserLang === 'it' || browserLang === 'es' || browserLang === 'pt') ? browserLang : 'en');
    if (isPlatformBrowser(this.platformId)) {
      if (!sessionStorage.getItem('language')) {
        sessionStorage.setItem('language',
          (browserLang === 'en' || browserLang === 'de' || browserLang === 'it' || browserLang === 'es' || browserLang === 'pt') ? browserLang : 'en');
      }
    }
    if (this.location.path() === '/login' || this.location.path() === '/admin') {
      this.hiddenHeader = true;
    }
  }

}
